import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from "../restricted-account-object/restricted-account-object.model";

export interface INoteArgs extends IRestrictedAccountObjectArgs {
    content: string;
    sensitive: boolean;
    job?: string;
}

const defaults = () => ({
    job: "",
    content: "",
    sensitive: true,
    account: ""
} as INoteArgs);

export class Note extends RestrictedAccountObject {
    content: string;
    sensitive: boolean;
    job: string;

    constructor(data?: INoteArgs) {
        super({...defaults(), ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.model.ts